// extracted by mini-css-extract-plugin
export default {"contributeButton":"ContributeButton_contributeButton__grwSb","contributeIcon":"ContributeButton_contributeIcon__o6B+K","breathing":"ContributeButton_breathing__cqY5I"};